import { Button } from "@simplybusiness/mobius";
import { StickyFooter, StickyFooterText } from "../shared/StickyFooter";

export const LiveChatIntervention = () => {
  return (
    <StickyFooter className="live-chat">
      <div className="live-chat__text">
        <StickyFooterText
          headlineText="Have questions about your quotes? Live chat with a consultant to
          understand your options."
          descriptionText=""
        />
      </div>
      <Button
        className="live-chat-intervention__button"
        variant="secondary"
        size="sm"
        data-testid="live-chat-intervention-button"
      >
        Open live chat
      </Button>
    </StickyFooter>
  );
};
